import { useQuery, useMutation } from "@apollo/client";
import {
  ORGANIZATION_EVENTS,
  CREATE_EVENT,
  UPDATE_EVENT,
  PUBLISH_EVENT,
  STOP_EVENT_RECURRENCE,
} from "../graphql";

interface UseOrganizationEventsOptions {
  organizationId: string;
  status?: string;
  limit?: number;
  offset?: number;
}

export function useOrganizationEvents({
  organizationId,
  status,
  limit = 50,
  offset = 0,
}: UseOrganizationEventsOptions) {
  return useQuery(ORGANIZATION_EVENTS, {
    variables: { organizationId, status, limit, offset },
    skip: !organizationId,
    fetchPolicy: "cache-and-network",
  });
}

export function useCreateEvent() {
  return useMutation(CREATE_EVENT, {
    refetchQueries: ["OrganizationEvents"],
  });
}

export function useUpdateEvent() {
  return useMutation(UPDATE_EVENT, {
    refetchQueries: ["OrganizationEvents"],
  });
}

export function usePublishEvent() {
  return useMutation(PUBLISH_EVENT, {
    refetchQueries: ["OrganizationEvents"],
  });
}

export function useStopEventRecurrence() {
  return useMutation(STOP_EVENT_RECURRENCE, {
    refetchQueries: ["OrganizationEvents"],
  });
}
